module.exports = __webpack_public_path__ + "static/media/10.b2d18a1b.png";